<script>
    import ibTab from './ib-tab.vue';
    export default {
        name: 'ib-tab2',
        mixins: [ibTab]
    }
</script>
